import { MarketplaceBanner, MobileMarketplaceBanner } from "../../shared/icons";
import styled from "styled-components";
import { screenSizes } from "../../styles/theme";
import AISearchBar from "../../components/shared-components/AISearchInput";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { searchNFTsAndCollections } from "../../slices/home/homeThunks";
import { showToast } from "../../slices/global/ToastSlice";
import { useNavigate } from "react-router-dom";

const HeroContainer = styled.section`
  background-image: url(${MarketplaceBanner});
  background-size: cover;
  background-position: center;
  height: 100vh;
  padding: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
    height: 100vh;
    background-image: none;
    background-color: #091C00;
    flex-direction: column;
    padding-top: 85px;
    justify-content: start;
  }
`;

const MobileBannerImage =styled.div`
  background-image: url(${MobileMarketplaceBanner});
  background-size: cover;
  width: 100%;
  height: 250px;
`;

const TextContainer = styled.div`
  color: #fff;
  .heading,
  .sub-heading {
    margin: 0;
    font-family: "Manrope", sans-serif;
    font-size: 80px;
    font-weight: 400;
    padding: 0;
    letter-spacing: -4px;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 64px;
    }
  }

  .sub-heading {
    margin-top: -20px;
  }

  .title {
    letter-spacing: -4px;
    font-family: "Manrope", sans-serif;
    font-size: 80px;
    font-weight: 700;
    background-color: rgba(9, 28, 0, 0.2);
    padding: 4px 0;
    display: inline-block;
    background-color: #3A4933;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 64px;
      width: auto;
      line-height: 72px;
    }
  }

  h6 {
    width: 60%;
    margin: 0;
    margin-top: 20px;
    font-family: "Manrope", sans-serif;
    font-size: 18px;
    line-height: 28px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    @media (max-width: ${screenSizes.L}px) {
      width: 100%;
    }
  }
`;

type HeroSectionProps = {
  onStartDiscovery: () => void;
  collectionDetails: string;
};

const HeroSection: React.FC<HeroSectionProps> = ({
  onStartDiscovery,
  collectionDetails,
}) => {
  const isMobile = window.innerWidth <= 768;
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchResults, setSearchResults] = useState<any>([]);
  const handleSearch = (query: string) => {
    if(!query.length){
      return;
    }
    setIsLoading(true);
    dispatch(searchNFTsAndCollections({ keyword: query, limit: 5 }))
      .then((res: any) => {
        if (res?.error) {
          throw new Error("Something went wrong");
        }
          const combinedData = res?.payload?.data?.data?.combinedData?.map((item: any) => ({
            id: item?._id,
            chain: item?.chain,
            name: item?.name,
            imageUrl: item?.featureImage || item?.fileUrl,
            score: item?.score || 0,
            price: (parseFloat(item?.floorPrice || 0).toFixed(4)),
            networkId: item?.networkId || 1,
            type: item?.assetType
          }));
        setSearchResults(combinedData);
      })
      .catch((err) => {
        setSearchResults([]);
        console.log({err})
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <HeroContainer>
      <TextContainer>
        <h2 className="heading">Navigate</h2>
        <span className="title">Asset Discovery</span>
        <h6>
        Cross-chain intelligence to empower users to explore and evaluate the impact of selected digital assets through a single search.
        </h6>
      </TextContainer>

      {isMobile &&
      <MobileBannerImage/>}
        <AISearchBar
          isHeaderSearch
          handleSearch={handleSearch}
          isLoading={isLoading}
          searchResults={searchResults}
          placeholder="Search for digital assets"
        />
    </HeroContainer>
  );
};

export default HeroSection;
